import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { colors } = constants;
const { fontSize, heading4Obj, heading5Obj, textLObj } = typographyStyles;

const { mediaQuery: mq } = mediaQueryStyles;
const { breakpoints } = constants;
const { BreakpointNames } = breakpoints;

const neutral600 = colors.ui.neutral[600];

export const modalCss = {
  root: {
    zIndex: 13,
  },

  title: {
    ...fontSize.heading3,
  },
  modalContentWrapper: {
    [mq.downTo(BreakpointNames.xs)]: {
      maxWidth: "800px",
    },
  },
  footer: {
    display: "none",
  },
};

export const activityPickerGradingButtonCss = {
  justifyContent: "center",
};

export const headingCss = {
  ...heading5Obj,
  margin: "24px 0 16px 0",
};

export const modalHeadingCss = {
  ...textLObj,
  fontWeight: "400",
  margin: "0",
};

export const assignmentHeaderCss = {
  ...heading4Obj,
  color: neutral600,
  fontWeight: "700",
  lineHeight: 1.5,
  marginBottom: "5px",
};

export const assigneeLabelCss = {
  fontWeight: "700",
  marginRight: "5px",
};

export const gradingModalContainerCss = {
  paddingTop: "32px",
};

export const iconCss = {
  "*": {
    strokeWidth: "3",
  },
};
